import { createStyles } from 'antd-style'

export default createStyles(() => {
  return {
    modal: {},
  }
})
